import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openCartModal, openWishlistModal } from '../modules/active_modal';
import { clearCartNotifications, clearWishlistNotifications } from '../modules/customer';

class ModalItemRemoval extends Component {

  constructor(props) {
    super(props);
    this.onConfirmClick = this.onConfirmClick.bind(this);
  }

  onConfirmClick(evt) {
    evt.preventDefault();
    switch (this.props.activeModal) {
      case 'cart':
        this.props.dispatch( clearCartNotifications() );
        break;
      case 'wishlist':
        this.props.dispatch( clearWishlistNotifications() );
        break;
    }
  }

  render() {
    let {dispatch} = this.props;
    let removedItems = (<li></li>);
    switch (this.props.activeModal) {
      case 'cart':
        removedItems = this.props.notifications.cart;
        break;
      case 'wishlist':
        removedItems = this.props.notifications.wishlist;
        break;
    }
    removedItems = removedItems.map(item => {
      let lpMedallion = item.format === 'large_print' ? <img className="removedImage-LP" src={"/images/theme-default/lp-icon.svg"} /> : '';
      return (
        <li>
          <div className="removedImage">
            <img className="removedImage-thumb" src={"//s3.amazonaws.com/bookspan-media/covers/thumb/" + item.mmid + ".jpg"} />
            {lpMedallion}
          </div>
          <div className="removedInfo">
            <span className="removedInfo-author">
              {item.name}
            </span>
            <span className="removedInfo-title highlight-color">
              {item.title}
            </span>
          </div>
        </li>
      );
    });

    return (
      <div className="modal-window itemremoval">
        <div className={"modal-close"} onClick={this.onConfirmClick}>&times;</div>
        <div>
          <h1 className="primary-color">Our apologies!</h1>
          <p className="nobottom">The following items are no longer available and have been removed from your {this.props.activeModal}.</p>
          <ul className="list">
            {removedItems}
          </ul>
          <p className="notop">Fortunately, we have hundreds of other amazing titles for you to choose from!</p>
          <button
          className="btn-primary"
          onClick={this.onConfirmClick}
          >Ok</button>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
      'activeModal': state.activeModal,
      'notifications': state.customer.notifications
    };
}

export default connect(mapStateToProps)(ModalItemRemoval);



// WEBPACK FOOTER //
// ./src/components/ModalItemRemoval.jsx